export * from './analysis.service';
import { AnalysisService } from './analysis.service';
export * from './analysis.serviceInterface';
export * from './analyticExport.service';
import { AnalyticExportService } from './analyticExport.service';
export * from './analyticExport.serviceInterface';
export * from './analyticMapData.service';
import { AnalyticMapDataService } from './analyticMapData.service';
export * from './analyticMapData.serviceInterface';
export * from './analytics.service';
import { AnalyticsService } from './analytics.service';
export * from './analytics.serviceInterface';
export * from './appRoute.service';
import { AppRouteService } from './appRoute.service';
export * from './appRoute.serviceInterface';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './auth.serviceInterface';
export * from './bridge.service';
import { BridgeService } from './bridge.service';
export * from './bridge.serviceInterface';
export * from './company.service';
import { CompanyService } from './company.service';
export * from './company.serviceInterface';
export * from './component.service';
import { ComponentService } from './component.service';
export * from './component.serviceInterface';
export * from './config.service';
import { ConfigService } from './config.service';
export * from './config.serviceInterface';
export * from './content.service';
import { ContentService } from './content.service';
export * from './content.serviceInterface';
export * from './datachange.service';
import { DatachangeService } from './datachange.service';
export * from './datachange.serviceInterface';
export * from './dataprocess.service';
import { DataprocessService } from './dataprocess.service';
export * from './dataprocess.serviceInterface';
export * from './entities.service';
import { EntitiesService } from './entities.service';
export * from './entities.serviceInterface';
export * from './home.service';
import { HomeService } from './home.service';
export * from './home.serviceInterface';
export * from './labelTranslation.service';
import { LabelTranslationService } from './labelTranslation.service';
export * from './labelTranslation.serviceInterface';
export * from './modelGenerator.service';
import { ModelGeneratorService } from './modelGenerator.service';
export * from './modelGenerator.serviceInterface';
export * from './pagelist.service';
import { PagelistService } from './pagelist.service';
export * from './pagelist.serviceInterface';
export * from './permission.service';
import { PermissionService } from './permission.service';
export * from './permission.serviceInterface';
export * from './roleMapping.service';
import { RoleMappingService } from './roleMapping.service';
export * from './roleMapping.serviceInterface';
export * from './roleUsers.service';
import { RoleUsersService } from './roleUsers.service';
export * from './roleUsers.serviceInterface';
export * from './roles.service';
import { RolesService } from './roles.service';
export * from './roles.serviceInterface';
export * from './scheduler.service';
import { SchedulerService } from './scheduler.service';
export * from './scheduler.serviceInterface';
export * from './structure.service';
import { StructureService } from './structure.service';
export * from './structure.serviceInterface';
export * from './structureDamage.service';
import { StructureDamageService } from './structureDamage.service';
export * from './structureDamage.serviceInterface';
export * from './structureGroup.service';
import { StructureGroupService } from './structureGroup.service';
export * from './structureGroup.serviceInterface';
export * from './translation.service';
import { TranslationService } from './translation.service';
export * from './translation.serviceInterface';
export * from './ui.service';
import { UiService } from './ui.service';
export * from './ui.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export * from './userRoles.service';
import { UserRolesService } from './userRoles.service';
export * from './userRoles.serviceInterface';
export * from './version.service';
import { VersionService } from './version.service';
export * from './version.serviceInterface';
export const APIS = [AnalysisService, AnalyticExportService, AnalyticMapDataService, AnalyticsService, AppRouteService, AuthService, BridgeService, CompanyService, ComponentService, ConfigService, ContentService, DatachangeService, DataprocessService, EntitiesService, HomeService, LabelTranslationService, ModelGeneratorService, PagelistService, PermissionService, RoleMappingService, RoleUsersService, RolesService, SchedulerService, StructureService, StructureDamageService, StructureGroupService, TranslationService, UiService, UserService, UserRolesService, VersionService];
